import React from 'react'
import Animation from '../../templates/Animation'

const FadePopUpTop = ({children, show, className, entryDelay}) => {
  return (
    <Animation
      className={className}
      show={show}
      animationOut="fade-pop-up-out-top"
      animationIn="fade-pop-up-in-top"
      entryDelay={entryDelay}
    >
      {children}
    </Animation>
  )
}

export default FadePopUpTop
